webpackJsonp([2],{

/***/ 725:
/*!********************************************!*\
  !*** ./src/pages/products/ProductEdit.vue ***!
  \********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ProductEdit_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductEdit.vue */ 863);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d92b002_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductEdit_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4d92b002","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductEdit.vue */ 917);
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ProductEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d92b002_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 727:
/*!********************************************!*\
  !*** ./node_modules/lodash/_copyObject.js ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(/*! ./_assignValue */ 732),
    baseAssignValue = __webpack_require__(/*! ./_baseAssignValue */ 390);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 728:
/*!**********************************************!*\
  !*** ./node_modules/lodash/_getPrototype.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(/*! ./_overArg */ 401);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 729:
/*!**************************************************!*\
  !*** ./node_modules/lodash/_cloneArrayBuffer.js ***!
  \**************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(/*! ./_Uint8Array */ 397);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 730:
/*!***************************************!*\
  !*** ./src/graphql/MediaFragment.gql ***!
  \***************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Media"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Media"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"length"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":63}};
    doc.loc.source = {"body":"fragment Media on Media {\n  id kind name mime length alt data\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["Media"] = oneQuery(doc, "Media");
        


/***/ }),

/***/ 731:
/*!************************************!*\
  !*** ./node_modules/lodash/map.js ***!
  \************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(/*! ./_arrayMap */ 391),
    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 120),
    baseMap = __webpack_require__(/*! ./_baseMap */ 735),
    isArray = __webpack_require__(/*! ./isArray */ 11);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ 732:
/*!*********************************************!*\
  !*** ./node_modules/lodash/_assignValue.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(/*! ./_baseAssignValue */ 390),
    eq = __webpack_require__(/*! ./eq */ 121);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 733:
/*!**********************************************!*\
  !*** ./node_modules/lodash/_getSymbolsIn.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(/*! ./_arrayPush */ 394),
    getPrototype = __webpack_require__(/*! ./_getPrototype */ 728),
    getSymbols = __webpack_require__(/*! ./_getSymbols */ 395),
    stubArray = __webpack_require__(/*! ./stubArray */ 400);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 734:
/*!**********************************************!*\
  !*** ./node_modules/lodash/_getAllKeysIn.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(/*! ./_baseGetAllKeys */ 399),
    getSymbolsIn = __webpack_require__(/*! ./_getSymbolsIn */ 733),
    keysIn = __webpack_require__(/*! ./keysIn */ 388);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 735:
/*!*****************************************!*\
  !*** ./node_modules/lodash/_baseMap.js ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(/*! ./_baseEach */ 122),
    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 72);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 736:
/*!******************************************!*\
  !*** ./node_modules/lodash/_overRest.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(/*! ./_apply */ 769);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 737:
/*!*********************************************!*\
  !*** ./node_modules/lodash/_setToString.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(/*! ./_baseSetToString */ 770),
    shortOut = __webpack_require__(/*! ./_shortOut */ 772);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 738:
/*!*************************************!*\
  !*** ./node_modules/lodash/omit.js ***!
  \*************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(/*! ./_arrayMap */ 391),
    baseClone = __webpack_require__(/*! ./_baseClone */ 747),
    baseUnset = __webpack_require__(/*! ./_baseUnset */ 763),
    castPath = __webpack_require__(/*! ./_castPath */ 119),
    copyObject = __webpack_require__(/*! ./_copyObject */ 727),
    customOmitClone = __webpack_require__(/*! ./_customOmitClone */ 767),
    flatRest = __webpack_require__(/*! ./_flatRest */ 745),
    getAllKeysIn = __webpack_require__(/*! ./_getAllKeysIn */ 734);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ 739:
/*!*********************************************!*\
  !*** ./node_modules/lodash/_baseFlatten.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(/*! ./_arrayPush */ 394),
    isFlattenable = __webpack_require__(/*! ./_isFlattenable */ 768);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 740:
/*!*********************************************!*\
  !*** ./node_modules/lodash/_cloneBuffer.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(/*! ./_root */ 15);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../webpack/buildin/module.js */ 76)(module)))

/***/ }),

/***/ 741:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_copyArray.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 742:
/*!*************************************************!*\
  !*** ./node_modules/lodash/_cloneTypedArray.js ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(/*! ./_cloneArrayBuffer */ 729);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 743:
/*!*************************************************!*\
  !*** ./node_modules/lodash/_initCloneObject.js ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(/*! ./_baseCreate */ 758),
    getPrototype = __webpack_require__(/*! ./_getPrototype */ 728),
    isPrototype = __webpack_require__(/*! ./_isPrototype */ 128);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 744:
/*!**********************************************!*\
  !*** ./node_modules/lodash/isPlainObject.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ 39),
    getPrototype = __webpack_require__(/*! ./_getPrototype */ 728),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 37);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 745:
/*!******************************************!*\
  !*** ./node_modules/lodash/_flatRest.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(/*! ./flatten */ 746),
    overRest = __webpack_require__(/*! ./_overRest */ 736),
    setToString = __webpack_require__(/*! ./_setToString */ 737);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ 746:
/*!****************************************!*\
  !*** ./node_modules/lodash/flatten.js ***!
  \****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(/*! ./_baseFlatten */ 739);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 747:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseClone.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(/*! ./_Stack */ 126),
    arrayEach = __webpack_require__(/*! ./_arrayEach */ 748),
    assignValue = __webpack_require__(/*! ./_assignValue */ 732),
    baseAssign = __webpack_require__(/*! ./_baseAssign */ 749),
    baseAssignIn = __webpack_require__(/*! ./_baseAssignIn */ 750),
    cloneBuffer = __webpack_require__(/*! ./_cloneBuffer */ 740),
    copyArray = __webpack_require__(/*! ./_copyArray */ 741),
    copySymbols = __webpack_require__(/*! ./_copySymbols */ 751),
    copySymbolsIn = __webpack_require__(/*! ./_copySymbolsIn */ 752),
    getAllKeys = __webpack_require__(/*! ./_getAllKeys */ 398),
    getAllKeysIn = __webpack_require__(/*! ./_getAllKeysIn */ 734),
    getTag = __webpack_require__(/*! ./_getTag */ 389),
    initCloneArray = __webpack_require__(/*! ./_initCloneArray */ 753),
    initCloneByTag = __webpack_require__(/*! ./_initCloneByTag */ 754),
    initCloneObject = __webpack_require__(/*! ./_initCloneObject */ 743),
    isArray = __webpack_require__(/*! ./isArray */ 11),
    isBuffer = __webpack_require__(/*! ./isBuffer */ 125),
    isMap = __webpack_require__(/*! ./isMap */ 759),
    isObject = __webpack_require__(/*! ./isObject */ 51),
    isSet = __webpack_require__(/*! ./isSet */ 761),
    keys = __webpack_require__(/*! ./keys */ 73),
    keysIn = __webpack_require__(/*! ./keysIn */ 388);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 748:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_arrayEach.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 749:
/*!********************************************!*\
  !*** ./node_modules/lodash/_baseAssign.js ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(/*! ./_copyObject */ 727),
    keys = __webpack_require__(/*! ./keys */ 73);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 750:
/*!**********************************************!*\
  !*** ./node_modules/lodash/_baseAssignIn.js ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(/*! ./_copyObject */ 727),
    keysIn = __webpack_require__(/*! ./keysIn */ 388);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 751:
/*!*********************************************!*\
  !*** ./node_modules/lodash/_copySymbols.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(/*! ./_copyObject */ 727),
    getSymbols = __webpack_require__(/*! ./_getSymbols */ 395);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 752:
/*!***********************************************!*\
  !*** ./node_modules/lodash/_copySymbolsIn.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(/*! ./_copyObject */ 727),
    getSymbolsIn = __webpack_require__(/*! ./_getSymbolsIn */ 733);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 753:
/*!************************************************!*\
  !*** ./node_modules/lodash/_initCloneArray.js ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 754:
/*!************************************************!*\
  !*** ./node_modules/lodash/_initCloneByTag.js ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(/*! ./_cloneArrayBuffer */ 729),
    cloneDataView = __webpack_require__(/*! ./_cloneDataView */ 755),
    cloneRegExp = __webpack_require__(/*! ./_cloneRegExp */ 756),
    cloneSymbol = __webpack_require__(/*! ./_cloneSymbol */ 757),
    cloneTypedArray = __webpack_require__(/*! ./_cloneTypedArray */ 742);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 755:
/*!***********************************************!*\
  !*** ./node_modules/lodash/_cloneDataView.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(/*! ./_cloneArrayBuffer */ 729);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 756:
/*!*********************************************!*\
  !*** ./node_modules/lodash/_cloneRegExp.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 757:
/*!*********************************************!*\
  !*** ./node_modules/lodash/_cloneSymbol.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ 52);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 758:
/*!********************************************!*\
  !*** ./node_modules/lodash/_baseCreate.js ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ./isObject */ 51);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 759:
/*!**************************************!*\
  !*** ./node_modules/lodash/isMap.js ***!
  \**************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(/*! ./_baseIsMap */ 760),
    baseUnary = __webpack_require__(/*! ./_baseUnary */ 392),
    nodeUtil = __webpack_require__(/*! ./_nodeUtil */ 393);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 760:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseIsMap.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(/*! ./_getTag */ 389),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 37);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 761:
/*!**************************************!*\
  !*** ./node_modules/lodash/isSet.js ***!
  \**************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(/*! ./_baseIsSet */ 762),
    baseUnary = __webpack_require__(/*! ./_baseUnary */ 392),
    nodeUtil = __webpack_require__(/*! ./_nodeUtil */ 393);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 762:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseIsSet.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(/*! ./_getTag */ 389),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 37);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 763:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseUnset.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(/*! ./_castPath */ 119),
    last = __webpack_require__(/*! ./last */ 764),
    parent = __webpack_require__(/*! ./_parent */ 765),
    toKey = __webpack_require__(/*! ./_toKey */ 53);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ 764:
/*!*************************************!*\
  !*** ./node_modules/lodash/last.js ***!
  \*************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 765:
/*!****************************************!*\
  !*** ./node_modules/lodash/_parent.js ***!
  \****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(/*! ./_baseGet */ 127),
    baseSlice = __webpack_require__(/*! ./_baseSlice */ 766);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ 766:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseSlice.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 767:
/*!*************************************************!*\
  !*** ./node_modules/lodash/_customOmitClone.js ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(/*! ./isPlainObject */ 744);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ 768:
/*!***********************************************!*\
  !*** ./node_modules/lodash/_isFlattenable.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ 52),
    isArguments = __webpack_require__(/*! ./isArguments */ 124),
    isArray = __webpack_require__(/*! ./isArray */ 11);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 769:
/*!***************************************!*\
  !*** ./node_modules/lodash/_apply.js ***!
  \***************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 770:
/*!*************************************************!*\
  !*** ./node_modules/lodash/_baseSetToString.js ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(/*! ./constant */ 771),
    defineProperty = __webpack_require__(/*! ./_defineProperty */ 402),
    identity = __webpack_require__(/*! ./identity */ 123);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 771:
/*!*****************************************!*\
  !*** ./node_modules/lodash/constant.js ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 772:
/*!******************************************!*\
  !*** ./node_modules/lodash/_shortOut.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 773:
/*!******************************************************************!*\
  !*** ./src/pages/collections/graphql/CollectionListFragment.gql ***!
  \******************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"published"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baseline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featured"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Media"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":229}};
    doc.loc.source = {"body":"#import \"../../../graphql/MediaFragment.gql\"\n\nfragment CollectionList on Collection {\n  id\n  name\n  published\n  baseline\n  featured\n  createdAt\n  updatedAt\n  categories {\n  \tid name\n  }\n  preview { ...Media }\n  products { id }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ../../../graphql/MediaFragment.gql */ 730).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CollectionList"] = oneQuery(doc, "CollectionList");
        


/***/ }),

/***/ 779:
/*!***************************************************************!*\
  !*** ./src/pages/collections/graphql/CollectionListQuery.gql ***!
  \***************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionFindAllInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"results"},"name":{"kind":"Name","value":"collectionsFindAll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionList"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":244}};
    doc.loc.source = {"body":"#import \"./CollectionListFragment.gql\"\n\nquery($pagination: PaginationInput, $filter: CollectionFindAllInput) {\n  results: collectionsFindAll(pagination: $pagination, filter: $filter) {\n\ttotalCount\n\tedges {\n\t  node { ...CollectionList }\n\t}\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ./CollectionListFragment.gql */ 773).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    


/***/ }),

/***/ 789:
/*!************************************************************!*\
  !*** ./src/pages/products/graphql/ProductListFragment.gql ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"published"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preview"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Media"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"combination"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"combinationPart"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":278}};
    doc.loc.source = {"body":"#import \"../../../graphql/MediaFragment.gql\"\n\nfragment ProductList on Product {\n  id\n  name\n  createdAt\n  updatedAt\n  published\n  kind\n  preview { ...Media }\n  collection { id name }\n  variants { reference }\n  combination { id name parts { id } }\n  combinationPart { id name }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ../../../graphql/MediaFragment.gql */ 730).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ProductList"] = oneQuery(doc, "ProductList");
        


/***/ }),

/***/ 790:
/*!*****************************!*\
  !*** ./src/common/types.js ***!
  \*****************************/
/*! exports provided: ProductKinds, ProductKindsArray, ProductStandards, ProductStandardsInfos, ProductStandardsArray, ProductPropertyKinds, ProductPropertyKindsArray, ProductPropertySexOptions, ProductPropertySexOptionsArray, ProductDefaultProperties */
/*! exports used: ProductDefaultProperties, ProductKinds, ProductKindsArray, ProductPropertyKindsArray, ProductPropertySexOptions, ProductPropertySexOptionsArray, ProductStandardsArray, ProductStandardsInfos */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProductKinds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ProductKindsArray; });
/* unused harmony export ProductStandards */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ProductStandardsInfos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ProductStandardsArray; });
/* unused harmony export ProductPropertyKinds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ProductPropertyKindsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ProductPropertySexOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ProductPropertySexOptionsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductDefaultProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/slicedToArray */ 130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(/*! lodash/map */ 731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);



//
// DO NOT FORGET TO CHANGE webapp/src/common/standards.js FILE TOO!
//
// DO NOT FORGET TO CHANGE webapp/src/common/standards.js FILE TOO!
//
// DO NOT FORGET TO CHANGE webapp/src/common/standards.js FILE TOO!
//

var ProductKinds = {
  clothing: "Vêtement",
  linen: "Linges",
  carpet: "Tapis",
  accessory: "Accessoires"
};
var ProductKindsArray = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(ProductKinds, function (label, value) {
  return {
    value: value,
    label: label
  };
});

var ProductStandards = ["ISO 20471-1", "ISO 20471-2", "ISO 20471-3", "ISO 11611-1", "ISO 11611-2", "EN 13034-6", "ISO 11612", "IEC 61482-2", "EN 1149-5", "EN 342", "EN 343", "EN 14058", "EN 14404"].sort(function (a, b) {
  // Clever sort
  var _$exec = /^(\w+)\s*(\d+)/.exec(a),
      _$exec2 = __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray___default()(_$exec, 3),
      allA = _$exec2[0],
      nameA = _$exec2[1],
      numberA = _$exec2[2];

  var _$exec3 = /^(\w+)\s*(\d+)/.exec(b),
      _$exec4 = __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray___default()(_$exec3, 3),
      allB = _$exec4[0],
      nameB = _$exec4[1],
      numberB = _$exec4[2];

  return !!nameA && nameA === nameB ? parseInt(numberA || "0", 10) - parseInt(numberB || "0", 10) : a.localeCompare(b);
});

var ProductStandardsInfos = {
  "ISO 20471-1": {
    name: "ISO 20471-1 - Risque de non visibilité - Classe 1",
    icon: "iso-20471-1",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Visibilit\xE9</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 20471-1</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M1.8,32.5H30v1.8H1.8V32.5z M5.1,6c0.3-0.3,0.6-0.6,1-0.9v19H1.8v-5.4C6.1,13.8,5.4,7.8,5.1,6 M15.9,1.8h0.1\n                c0.6,0,2.6,0.1,4.9,0.8l-5.1,7.5l-5-7.5c2.3-0.7,4.2-0.8,4.8-0.8H15.9z M30,29.6H1.8V27H30V29.6z M22.8,3.3v20.8h-6.1V11.7l5.8-8.6\n                C22.6,3.2,22.7,3.2,22.8,3.3 M9.4,3.1l5.7,8.6v12.4H9V3.3C9.1,3.2,9.3,3.2,9.4,3.1 M30,18.7v5.4h-4.3v-19c0.3,0.3,0.7,0.6,1,0.9\n                C26.4,7.8,25.7,13.8,30,18.7 M31.5,17.7C27,12.8,28.5,6,28.5,6l0.1-0.4l-0.3-0.3C24.1,0.3,17.4,0,16.1,0l-0.1,0l-0.2,0\n                c-1.3,0-8,0.3-12.2,5.2L3.2,5.5L3.3,6c0,0.1,1.6,6.8-3,11.7L0,18v18.1h31.8V18L31.5,17.7z\"/>\n            </g>\n          </svg>"
  },
  "ISO 20471-2": {
    name: "ISO 20471-2 - Risque de non visibilité - Classe 2",
    icon: "iso-20471-2",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Visibilit\xE9</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 20471-2</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M1.8,32.5H30v1.8H1.8V32.5z M5.1,6c0.3-0.3,0.6-0.6,1-0.9v19H1.8v-5.4C6.1,13.8,5.4,7.8,5.1,6 M15.9,1.8h0.1\n                c0.6,0,2.6,0.1,4.9,0.8l-5.1,7.5l-5-7.5c2.3-0.7,4.2-0.8,4.8-0.8H15.9z M30,29.6H1.8V27H30V29.6z M22.8,3.3v20.8h-6.1V11.7l5.8-8.6\n                C22.6,3.2,22.7,3.2,22.8,3.3 M9.4,3.1l5.7,8.6v12.4H9V3.3C9.1,3.2,9.3,3.2,9.4,3.1 M30,18.7v5.4h-4.3v-19c0.3,0.3,0.7,0.6,1,0.9\n                C26.4,7.8,25.7,13.8,30,18.7 M31.5,17.7C27,12.8,28.5,6,28.5,6l0.1-0.4l-0.3-0.3C24.1,0.3,17.4,0,16.1,0l-0.1,0l-0.2,0\n                c-1.3,0-8,0.3-12.2,5.2L3.2,5.5L3.3,6c0,0.1,1.6,6.8-3,11.7L0,18v18.1h31.8V18L31.5,17.7z\"/>\n            </g>\n          </svg>"
  },
  "ISO 20471-3": {
    name: "ISO 20471-3 - Risque de non visibilité - Classe 3",
    icon: "iso-20471-3",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Visibilit\xE9</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 20471-3</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M1.8,32.5H30v1.8H1.8V32.5z M5.1,6c0.3-0.3,0.6-0.6,1-0.9v19H1.8v-5.4C6.1,13.8,5.4,7.8,5.1,6 M15.9,1.8h0.1\n                c0.6,0,2.6,0.1,4.9,0.8l-5.1,7.5l-5-7.5c2.3-0.7,4.2-0.8,4.8-0.8H15.9z M30,29.6H1.8V27H30V29.6z M22.8,3.3v20.8h-6.1V11.7l5.8-8.6\n                C22.6,3.2,22.7,3.2,22.8,3.3 M9.4,3.1l5.7,8.6v12.4H9V3.3C9.1,3.2,9.3,3.2,9.4,3.1 M30,18.7v5.4h-4.3v-19c0.3,0.3,0.7,0.6,1,0.9\n                C26.4,7.8,25.7,13.8,30,18.7 M31.5,17.7C27,12.8,28.5,6,28.5,6l0.1-0.4l-0.3-0.3C24.1,0.3,17.4,0,16.1,0l-0.1,0l-0.2,0\n                c-1.3,0-8,0.3-12.2,5.2L3.2,5.5L3.3,6c0,0.1,1.6,6.8-3,11.7L0,18v18.1h31.8V18L31.5,17.7z\"/>\n            </g>\n          </svg>"
  },
  "ISO 11611-1": {
    name: "ISO 11611-1 - Risque thermique : chaleur et flammes - Classe 1",
    icon: "iso-11611-1",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Soudage</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 11611-1</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M6.6,23.5h16.5c0.1,0,0.2-0.1,0.2-0.2v-2.1c0-0.1-0.1-0.2-0.2-0.2H6.6c-0.1,0-0.2,0.1-0.2,0.2v2.1\n                C6.4,23.4,6.5,23.5,6.6,23.5\"/>\n              <path d=\"M15.4,8.1c0-0.1,0.1-0.2,0.2-0.2h1.9c0.1,0,0.2,0.1,0.2,0.2v1c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.2-0.1-0.2-0.2V8.1z\n                 M14.2,10.8h0.9c0.1,0,0.2,0.1,0.2,0.2l-1,5.6c0,0.1,0.1,0.2,0.2,0.2l1,0.2c0.1,0,0.2,0,0.2-0.2l1-5.8c0-0.1,0.1-0.2,0.2-0.2h7.6\n                c0.1,0,0.2-0.1,0.2-0.2V9.5c0-0.1-0.1-0.2-0.2-0.2h-5.1c-0.1,0-0.2-0.1-0.2-0.2v-1c0-0.1,0.1-0.2,0.2-0.2h5.1c0.1,0,0.2-0.1,0.2-0.2\n                V6.6c0-0.1-0.1-0.2-0.2-0.2H14.2C14,6.4,14,6.5,14,6.6v4C14,10.7,14,10.8,14.2,10.8\"/>\n              <path d=\"M9.1,20.2c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C8.2,19.9,8.6,20.2,9.1,20.2\"/>\n              <path d=\"M10.2,17.9c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C9.4,17.6,9.8,17.9,10.2,17.9\"/>\n              <path d=\"M12.4,16.5c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C11.6,16.2,12,16.5,12.4,16.5\"/>\n              <path d=\"M18.1,17.1c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8C17.7,17.9,18.1,17.6,18.1,17.1\"/>\n              <path d=\"M18.4,20.2c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C17.6,19.9,18,20.2,18.4,20.2\"/>\n            </g>\n          </svg>"
  },
  "ISO 11611-2": {
    name: "ISO 11611-2 - Risque thermique : chaleur et flammes - Classe 2",
    icon: "iso-11611-2",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Soudage</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 11611-2</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M6.6,23.5h16.5c0.1,0,0.2-0.1,0.2-0.2v-2.1c0-0.1-0.1-0.2-0.2-0.2H6.6c-0.1,0-0.2,0.1-0.2,0.2v2.1\n                C6.4,23.4,6.5,23.5,6.6,23.5\"/>\n              <path d=\"M15.4,8.1c0-0.1,0.1-0.2,0.2-0.2h1.9c0.1,0,0.2,0.1,0.2,0.2v1c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.2-0.1-0.2-0.2V8.1z\n                 M14.2,10.8h0.9c0.1,0,0.2,0.1,0.2,0.2l-1,5.6c0,0.1,0.1,0.2,0.2,0.2l1,0.2c0.1,0,0.2,0,0.2-0.2l1-5.8c0-0.1,0.1-0.2,0.2-0.2h7.6\n                c0.1,0,0.2-0.1,0.2-0.2V9.5c0-0.1-0.1-0.2-0.2-0.2h-5.1c-0.1,0-0.2-0.1-0.2-0.2v-1c0-0.1,0.1-0.2,0.2-0.2h5.1c0.1,0,0.2-0.1,0.2-0.2\n                V6.6c0-0.1-0.1-0.2-0.2-0.2H14.2C14,6.4,14,6.5,14,6.6v4C14,10.7,14,10.8,14.2,10.8\"/>\n              <path d=\"M9.1,20.2c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C8.2,19.9,8.6,20.2,9.1,20.2\"/>\n              <path d=\"M10.2,17.9c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C9.4,17.6,9.8,17.9,10.2,17.9\"/>\n              <path d=\"M12.4,16.5c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C11.6,16.2,12,16.5,12.4,16.5\"/>\n              <path d=\"M18.1,17.1c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8C17.7,17.9,18.1,17.6,18.1,17.1\"/>\n              <path d=\"M18.4,20.2c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C17.6,19.9,18,20.2,18.4,20.2\"/>\n            </g>\n          </svg>"
  },
  "EN 13034-6": {
    name: "EN 13034-6 - Risque produits liquides chimiques",
    icon: "en-13034-6",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 66\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Produits</text>\n            <text transform=\"translate(25 54)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">chimiques</text>\n            <text transform=\"translate(25 66)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 13034-6</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M10.1,28h10.6c0.9,0,1.5-0.2,1.8-0.7c0.5-0.7,0.1-1.6,0.1-1.6c0,0-3.2-11-3.9-13.2c-0.6-2.1-0.2-3-0.1-3.1L19.7,7\n                c0.1-0.2,0-0.4-0.2-0.4c-0.2-0.1-0.4,0-0.4,0.2L18,9c-0.1,0.1-0.6,1.1,0.1,3.6c0.2,0.6,0.6,1.9,1,3.5h-7.4c0.5-1.5,0.8-2.8,1-3.5\n                c0.7-2.4,0.2-3.5,0.1-3.5l-1.1-2.4c-0.1-0.2-0.3-0.2-0.4-0.2C11.1,6.6,11,6.8,11.1,7l1.1,2.4c0,0,0.5,0.9-0.2,3\n                c-0.7,2.3-3.9,13.2-3.9,13.2c0,0-0.4,1,0.1,1.7C8.6,27.8,9.2,28,10.1,28\"/>\n              <path d=\"M17.2,5.2c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1\n                c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1\n                s0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1\n                c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2c-0.3,0-0.4,0.1-0.5,0.1C23.8,5,23.7,5,23.5,5\n                c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.4,0.1-0.5,0.1C22,5,21.9,5,21.7,5c-0.2,0-0.3,0-0.4-0.1\n                c-0.1-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.4,0.1-0.5,0.1C20.2,5,20.1,5,19.9,5c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1\n                c-0.3,0-0.4,0.1-0.5,0.1C18.4,5,18.3,5,18.1,5c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1C17.1,4.8,17,4.9,17,5\n                C17,5.1,17.1,5.2,17.2,5.2\"/>\n              <path d=\"M17.2,4.4c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1\n                c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1\n                s0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1\n                c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1\n                c-0.2,0-0.3,0-0.4-0.1C23,4.1,22.9,4,22.6,4c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4-0.1\n                C21.2,4.1,21.1,4,20.8,4c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4-0.1C19.4,4.1,19.2,4,19,4\n                c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4-0.1C17.6,4.1,17.4,4,17.2,4C17.1,4,17,4.1,17,4.2\n                C17,4.3,17.1,4.4,17.2,4.4\"/>\n              <path d=\"M19.9,3.8c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1\n                c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1\n                c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1\n                c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1s-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4-0.1\n                c-0.1-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.2,0.1-0.2,0.2C19.7,3.7,19.8,3.8,19.9,3.8\"/>\n              <path d=\"M24.4,5.6c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1\n                c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1s-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.4,0.1-0.5,0.1\n                c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2c0.3,0,0.4-0.1,0.5-0.1C20.5,6,20.6,6,20.8,6\n                c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1C22.3,6,22.4,6,22.6,6c0.2,0,0.3,0,0.4,0.1\n                c0.1,0.1,0.3,0.1,0.5,0.1s0.4-0.1,0.5-0.1C24.1,6,24.2,6,24.4,6c0.1,0,0.2-0.1,0.2-0.2C24.6,5.7,24.5,5.6,24.4,5.6\"/>\n            </g>\n          </svg>"
  },
  "ISO 11612": {
    name: "ISO 11612 - Risque soudage chaleurs et projections",
    icon: "iso-11612",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 66\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Chaleurs et</text>\n            <text transform=\"translate(25 54)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">flammes</text>\n            <text transform=\"translate(25 66)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 11612</text>\n            <g transform=\"translate(9.55 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M10.9,28.3c1.3,0.4,1.5,0,1.5,0c-2.3-1-3-4.2-2-6.7c2.2,2.3,1.9-1.7,1.7-3c1.3,0.5,1.2,4.1,3.3,4.7\n                c-1.4-2.5,0.7-6.8-0.1-8.1c1.6,0.8,1.6,4.1,1.4,5.1c1.4-0.9,0.3-2.7,1.3-4.2c-0.4,1,1.2,3.7,0,5.8c1.2,0.5,1.3-2.1,2.5-1.8\n                c-0.6,0.6,0.2,2.5,0.2,4.5c0,1.6-0.8,3.1-2.2,3.8c0,0,1.1,0.1,1.5,0c2-0.6,3.5-3.2,3.5-5.7c-0.1-3.6-2.2-8.2-1.1-9.5\n                c-1.6-0.1-1.7,2.5-3.1,2.8c0.9-1.6,0.7-3.7-0.4-5.4c-0.7-1.2-0.8-2.8,0-3.5c-1.5,0.4-2.3,3-1.9,5.1c-2-3.1,0.9-6.8-0.5-9\n                c0.4,1.1-1.7,3.4-2.8,5.9c-0.9,2-0.8,5,0.2,7.7c-2.7-2.6-0.4-6.8-2.4-8c1,1.6-2.4,3.4-0.7,7.6c-0.6,0.5-1.1-1.8-2.3-1.3\n                c0.7,0.9-0.5,4.3-0.8,5.8C6.9,24.7,8.4,27.6,10.9,28.3\"/>\n            </g>\n          </svg>"
  },
  "IEC 61482-2": {
    name: "IEC 61482-2 - Risque d'arc électrique",
    icon: "iec-61482-2",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 66\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Arc</text>\n            <text transform=\"translate(25 54)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">\xE9lectrique</text>\n            <text transform=\"translate(25 66)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">IEC 61482-2</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M7.7,16.1l7.8-11.2l7.8,11.2h-5l-2.8-4l-2.8,4H7.7z M7.1,25.5l8.3-12l8.3,12H7.1z M25.4,26.3l-6.5-9.4h6L15.5,3.5L6.1,16.9\n                h6l-6.5,9.4H25.4z\"/>\n            </g>\n          </svg>"
  },
  "EN 1149-5": {
    name: "EN 1149-5 - Risque d'électricité statique",
    icon: "en-1149-5",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 66\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">\xC9lectricit\xE9</text>\n            <text transform=\"translate(25 54)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">statique</text>\n            <text transform=\"translate(25 66)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">EN 1149-5</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M7.4,26.5h16.2c0.1,0,0.2-0.1,0.2-0.2v-2c0-0.1-0.1-0.2-0.2-0.2h-7.4l4.9-13.2l-9,5.1l2.7-8.2c0,0,0,0,0.1,0\n                c1,0,1.9-0.8,1.9-1.9c0-1-0.8-1.9-1.9-1.9c-1,0-1.9,0.8-1.9,1.9c0,0.6,0.3,1.1,0.7,1.5l-3.7,11.1l8.8-5l-4,10.7H7.4\n                c-0.1,0-0.2,0.1-0.2,0.2v2C7.2,26.4,7.3,26.5,7.4,26.5\"/>\n            </g>\n          </svg>"
  },
  "EN 342": {
    name: "EN 342 - Risque froid : de -5° jusqu'à -50°C",
    icon: "en-342",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Froid</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">EN 342</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M15.6,22.3l-5.2-3v-5.7l5-2.9l5.2,3v5.8L15.6,22.3z M25,18.7l-0.8-1.4l-2,1.2v-3.9l1.9,1.1l0.8-1.4l-2-1.1l4-2.4l-0.8-1.4\n                l-4,2.3V9.4h-1.6v2.4l-3.5-2L19,8.6l-0.8-1.4l-1.9,1.1V3.8h-1.6v4.6l-2.1-1.2l-0.8,1.4l2,1.2l-3.4,2V9.4H8.8v2.3l-4-2.3L4,10.7\n                l4.1,2.3l-2.2,1.3l0.8,1.4l2.1-1.2v3.9l-2-1.2L6,18.6l2.1,1.2L4,22.2l0.8,1.4l4-2.4v2.2h1.6v-2.3l3.6,2.1l-2.1,1.2l0.8,1.4l1.9-1.1\n                v4.6h1.6v-4.8l2.1,1.2l0.8-1.4l-1.9-1.1l3.4-2v2.2h1.6v-2.1l3.9,2.3l0.8-1.4l-4-2.3L25,18.7z\"/>\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n            </g>\n          </svg>"
  },
  "EN 343": {
    name: "EN 343 - Risque intempéries",
    icon: "en-343",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Intemp\xE9ries</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">EN 343</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n                <path d=\"M15.1,16.9c-0.9,0.1-1.5,0.5-2.1,1.2c-0.6-0.7-1.4-1.2-2.3-1.2c-1,0-1.7,0.5-2.3,1.2c-0.6-0.6-1.2-1.1-2.1-1.2\n                  c-0.9-0.1-1.6,0.2-2.2,0.8c0,0,0,0,0,0c0.1-0.3,0.1-0.5,0.2-0.8c0.4-1.1,1-2.1,1.7-2.9c1.1-1.2,2.4-2.2,4-2.8\n                  c1-0.5,2.1-0.8,3.2-0.9c0.6-0.1,1.2-0.2,1.9-0.2c0,0,0,0,0.1,0c0,0,0-0.1,0-0.1c0-0.2,0-0.4,0-0.6c0-0.2,0.1-0.4,0.3-0.4\n                  c0.2,0,0.4,0.1,0.4,0.3c0,0.2,0,0.4,0,0.6c0,0,0,0.1,0,0.1c0.2,0,0.3,0,0.5,0c1.1,0.1,2.2,0.3,3.3,0.6c1.4,0.4,2.6,1,3.8,1.9\n                  c1.1,0.8,1.9,1.7,2.6,2.9c0.4,0.8,0.8,1.8,0.9,2.5c-0.6-0.7-1.4-1.1-2.3-1.1c-0.9,0-1.6,0.5-2.3,1.2c-0.6-0.7-1.4-1.2-2.3-1.2\n                  c-1,0-1.7,0.5-2.3,1.2c-0.5-0.6-1.1-1-1.9-1.1c0,0,0,0.1,0,0.1c0,3.3,0,6.5,0,9.8c0,0.2,0,0.4,0.1,0.6c0.2,0.5,0.5,0.6,1.1,0.6\n                  c0.3,0,0.6-0.2,0.7-0.5c0.1-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.3,0-0.4c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.3\n                  c0,0.7-0.1,1.4-0.7,1.9c-0.2,0.2-0.4,0.2-0.7,0.3c-0.4,0-0.8,0-1.2-0.2c-0.4-0.2-0.7-0.6-0.8-1.1c-0.1-0.2-0.1-0.4-0.1-0.6\n                  c0-3.3,0-6.5,0-9.8C15.1,17,15.1,17,15.1,16.9z\"/>\n              <path d=\"M18.6,8.7c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1c0.3-0.3,1.5-0.5,1.5-0.5S18.9,8.4,18.6,8.7z\"/>\n              <path d=\"M17.4,6.4c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1s1.5-0.5,1.5-0.5S17.7,6.2,17.4,6.4z\"/>\n              <path d=\"M24.4,6.4c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1S25,4.9,25,4.9S24.7,6.2,24.4,6.4z\"/>\n              <path d=\"M21.2,4.7c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1s1.5-0.5,1.5-0.5S21.5,4.5,21.2,4.7z\"/>\n              <path d=\"M13.9,7.9c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1s1.5-0.5,1.5-0.5S14.1,7.7,13.9,7.9z\"/>\n              <path d=\"M21.2,6.7c-0.3,0.3-0.7,0.3-1,0c-0.3-0.3-0.3-0.7,0-1c0.3-0.3,1.5-0.5,1.5-0.5S21.5,6.5,21.2,6.7z\"/>\n              <path d=\"M21.7,9.4c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1s1.5-0.5,1.5-0.5S22,9.2,21.7,9.4z\"/>\n            </g>\n          </svg>"
  },
  "EN 14058": {
    name: "EN 14058 - Risque frais : au dessus de -5°C",
    icon: "en-14058",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Frais</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">EN 14058</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M15.6,22.3l-5.2-3v-5.7l5-2.9l5.2,3v5.8L15.6,22.3z M25,18.7l-0.8-1.4l-2,1.2v-3.9l1.9,1.1l0.8-1.4l-2-1.1l4-2.4l-0.8-1.4\n                l-4,2.3V9.4h-1.6v2.4l-3.5-2L19,8.6l-0.8-1.4l-1.9,1.1V3.8h-1.6v4.6l-2.1-1.2l-0.8,1.4l2,1.2l-3.4,2V9.4H8.8v2.3l-4-2.3L4,10.7\n                l4.1,2.3l-2.2,1.3l0.8,1.4l2.1-1.2v3.9l-2-1.2L6,18.6l2.1,1.2L4,22.2l0.8,1.4l4-2.4v2.2h1.6v-2.3l3.6,2.1l-2.1,1.2l0.8,1.4l1.9-1.1\n                v4.6h1.6v-4.8l2.1,1.2l0.8-1.4l-1.9-1.1l3.4-2v2.2h1.6v-2.1l3.9,2.3l0.8-1.4l-4-2.3L25,18.7z\"/>\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n            </g>\n          </svg>"
  },
  "EN 14404": {
    name: "EN 14404 - Risque hygroma du genoux",
    icon: "en-14404",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Genoux</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">EN 14404</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M16.2,20.5H7.9v-8.5h3.7c0.2-0.1,0.2-1,0.2-1.5c0-1,0-2.2,0.7-2.9C12.9,7.2,13.3,7,13.9,7h2.3v5.8h9.5V14h-9.5v1.6h9.5v1.1\n                h-9.5V20.5z\"/>\n              <rect x=\"5.2\" y=\"22.3\" width=\"13.2\" height=\"2.3\"/>\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n            </g>\n          </svg>"
  }
};

var ProductStandardsArray = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(ProductStandards, function (value) {
  return {
    value: value,
    label: (ProductStandardsInfos[value] || { name: value }).name
  };
});

var ProductPropertyKinds = {
  tag: "Choix prédéfini",
  sex: "Sexe",
  color: "Couleur",
  text: "Texte libre"
};
var ProductPropertyKindsArray = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(ProductPropertyKinds, function (label, value) {
  return { value: value, label: label };
});

var ProductPropertySexOptions = {
  male: "Homme",
  female: "Femme",
  unisex: "Unisexe"
};
var ProductPropertySexOptionsArray = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(ProductPropertySexOptions, function (label, value) {
  return { value: value, label: label };
});

var ProductDefaultProperties = {
  clothing: [{ name: "Sexe", kind: "sex", required: true },
  //{name: 'Classe', kind: 'tag', required: false},
  //{name: 'Type', kind: 'tag', required: false},
  { name: "Matière", kind: "tag", required: false, tags: ["PC", "CR"] }, { name: "Couleur", kind: "color", required: true, colors: [] }, { name: "Liseré", kind: "color", required: false, colors: [] }, { name: "Parement", kind: "color", required: false, colors: [] }],
  carpet: [{ name: "Couleur", kind: "color", required: true, colors: [] }, { name: "Taille", kind: "tag", required: true }, { name: "Format", kind: "tag", tags: ["Portrait", "Paysage"] }],
  linen: [{ name: "Couleur", kind: "color", required: true, colors: [] }, { name: "Taille", kind: "tag", required: true }, {
    name: "Volant",
    kind: "tag",
    required: false,
    tags: ["Avec volant", "Sans volant"]
  }, { name: "Données techniques", kind: "text", required: false }],
  accessory: []
};

/***/ }),

/***/ 792:
/*!**************************************************************!*\
  !*** ./src/pages/products/graphql/ProductDetailFragment.gql ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductList"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"combination"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"combinationPart"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"required"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"colors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"standards"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":259}};
    doc.loc.source = {"body":"#import \"./ProductListFragment.gql\"\n\nfragment ProductDetail on Product {\n  ...ProductList\n  order\n  fullImage\n  combination { id name }\n  combinationPart { id name }\n  properties { id name kind required colors { id name } tags }\n  images { id }\n  standards\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ./ProductListFragment.gql */ 789).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ProductDetail"] = oneQuery(doc, "ProductDetail");
        


/***/ }),

/***/ 798:
/*!***********************************************!*\
  !*** ./node_modules/lodash/_arrayIncludes.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(/*! ./_baseIndexOf */ 809);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 799:
/*!***************************************************!*\
  !*** ./node_modules/lodash/_arrayIncludesWith.js ***!
  \***************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 802:
/*!********************************************************!*\
  !*** ./src/pages/colors/graphql/ColorListFragment.gql ***!
  \********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ColorList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Color"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"group"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"kind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"colors"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":76}};
    doc.loc.source = {"body":"fragment ColorList on Color {\n  id\n  name\n  group { name }\n  kind\n  colors\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ColorList"] = oneQuery(doc, "ColorList");
        


/***/ }),

/***/ 805:
/*!******************************************************!*\
  !*** ./src/pages/colors/graphql/ColorsListQuery.gql ***!
  \******************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ColorFindAllInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"results"},"name":{"kind":"Name","value":"colorsFindAll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorList"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":224}};
    doc.loc.source = {"body":"#import \"./ColorListFragment.gql\"\n\nquery($pagination: PaginationInput, $filter: ColorFindAllInput) {\n  results: colorsFindAll(pagination: $pagination, filter: $filter) {\n\ttotalCount\n\tedges {\n\t  node { ...ColorList }\n\t}\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ./ColorListFragment.gql */ 802).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    


/***/ }),

/***/ 806:
/*!**************************************************************!*\
  !*** ./src/pages/products/graphql/ProductUpdateMutation.gql ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductDetail"},"directives":[]}]}}]}}],"loc":{"start":0,"end":148}};
    doc.loc.source = {"body":"#import \"./ProductDetailFragment.gql\"\n\nmutation($id: ID!, $data: ProductInput) {\n  productUpdate(id: $id, data: $data) {\n    ...ProductDetail\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ./ProductDetailFragment.gql */ 792).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    


/***/ }),

/***/ 807:
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/products/ProductForm.vue ***!
  \***************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/objectWithoutProperties */ 817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/extends */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/toConsumableArray */ 131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(/*! lodash/get */ 413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_omit__ = __webpack_require__(/*! lodash/omit */ 738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map__ = __webpack_require__(/*! lodash/map */ 731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_xor__ = __webpack_require__(/*! lodash/xor */ 831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_xor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_xor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_types__ = __webpack_require__(/*! ../../common/types */ 790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__colors_graphql_ColorsListQuery_gql__ = __webpack_require__(/*! ../colors/graphql/ColorsListQuery.gql */ 805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__colors_graphql_ColorsListQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__colors_graphql_ColorsListQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__collections_graphql_CollectionListQuery_gql__ = __webpack_require__(/*! ../collections/graphql/CollectionListQuery.gql */ 779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__collections_graphql_CollectionListQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__collections_graphql_CollectionListQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__combinations_graphql_CombinationListQuery_gql__ = __webpack_require__(/*! ../combinations/graphql/CombinationListQuery.gql */ 818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__combinations_graphql_CombinationListQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__combinations_graphql_CombinationListQuery_gql__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormStickyHeader: function FormStickyHeader() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, /*! ../../components/FormStickyHeader */ 396));
    },
    FormFileUpload: function FormFileUpload() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, /*! ../../components/FormFileUpload */ 403));
    },
    FormOrder: function FormOrder() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, /*! ../../components/FormOrder */ 405));
    },
    FormSelectColor: function FormSelectColor() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, /*! ../../components/FormSelectColor */ 414));
    },
    FormSwitch: function FormSwitch() {
      return __webpack_require__.e/* import() */(18/* duplicate */).then(__webpack_require__.bind(null, /*! package-common-vuejs/src/components/form/FormSwitch */ 791));
    },
    FormTags: function FormTags() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, /*! package-common-vuejs/src/components/form/FormTags */ 858));
    },
    Combinations: function Combinations() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, /*! ../combinations/Combinations */ 860));
    },
    Modal: function Modal() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, /*! package-common-vuejs/src/components/Modal */ 132));
    },
    FormMultiselect: function FormMultiselect() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, /*! package-common-vuejs/src/components/form/FormMultiselect */ 711));
    }
  },
  props: {
    title: String,
    value: Object
  },
  apollo: {
    colors: {
      query: __WEBPACK_IMPORTED_MODULE_8__colors_graphql_ColorsListQuery_gql___default.a,
      fetchPolicy: "network-only",
      variables: function variables() {
        return {
          pagination: {
            limit: 999
          }
        };
      },

      update: function update(data) {
        return __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(data.results.edges, "node");
      }
    },
    collections: {
      query: __WEBPACK_IMPORTED_MODULE_9__collections_graphql_CollectionListQuery_gql___default.a,
      fetchPolicy: "network-only",
      variables: function variables() {
        return {
          pagination: {
            limit: 999
          }
        };
      },

      update: function update(data) {
        return __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(data.results.edges, function (_ref) {
          var _ref$node = _ref.node,
              id = _ref$node.id,
              name = _ref$node.name;
          return {
            value: id,
            label: name
          };
        });
      }
    },
    combinations: {
      query: __WEBPACK_IMPORTED_MODULE_10__combinations_graphql_CombinationListQuery_gql___default.a,
      fetchPolicy: "network-only",
      variables: function variables() {
        return {
          pagination: {
            limit: 999
          }
        };
      },

      update: function update(data) {
        return __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(data.results.edges, function (_ref2) {
          var _ref2$node = _ref2.node,
              id = _ref2$node.id,
              name = _ref2$node.name,
              parts = _ref2$node.parts;
          return {
            value: id,
            label: name,
            children: (parts || []).map(function (_ref3) {
              var id = _ref3.id,
                  name = _ref3.name;
              return {
                value: id,
                label: name
              };
            })
          };
        });
      }
    }
  },
  data: function data() {
    return {
      model: {},
      collections: [],
      combinations: [],
      colors: [],

      modelHasCombination: false,

      combinationsManagerVisible: false,

      ProductKinds: __WEBPACK_IMPORTED_MODULE_7__common_types__["c" /* ProductKindsArray */],
      ProductPropertyKinds: __WEBPACK_IMPORTED_MODULE_7__common_types__["d" /* ProductPropertyKindsArray */],
      ProductStandards: __WEBPACK_IMPORTED_MODULE_7__common_types__["g" /* ProductStandardsArray */],
      ProductStandardsInfos: __WEBPACK_IMPORTED_MODULE_7__common_types__["h" /* ProductStandardsInfos */]
    };
  },

  computed: {
    modelCombination: {
      get: function get() {
        return this.model.combinationPart;
      },
      set: function set(value) {
        if (!value) {
          this.model.combination = null;
          this.model.combinationPart = null;
          return;
        }
        var combination = (this.combinations || []).find(function (_ref4) {
          var children = _ref4.children;
          return !!children.find(function (_ref5) {
            var childValue = _ref5.value;
            return childValue === value;
          });
        });
        this.model.combination = combination.value;
        this.model.combinationPart = value;
      }
    }
  },
  created: function created() {
    this.updateModel(this.value);
    if (this.value && !this.value.id) {
      // On creation
      this.onChangeKind(this.value.kind);
    }
  },

  watch: {
    value: function value() {
      this.updateModel(this.value);
    }
  },
  methods: {
    openCombinationsManager: function openCombinationsManager() {
      this.combinationsManagerVisible = true;
    },
    hideCombinationsManager: function hideCombinationsManager() {
      this.$apollo.queries.combinations.refetch();
      this.combinationsManagerVisible = false;
    },
    onChangeKind: function onChangeKind(kind) {
      this.model.properties = __WEBPACK_IMPORTED_MODULE_7__common_types__["a" /* ProductDefaultProperties */][kind] || [];
    },
    isDuplicateSexProperty: function isDuplicateSexProperty(_ref6) {
      var kind = _ref6.kind;

      return kind === "sex" && (this.model.properties || []).filter(function (_ref7) {
        var kind = _ref7.kind;
        return kind === "sex";
      }).length > 1;
    },
    addProperty: function addProperty() {
      this.$set(this.model, "properties", [].concat(__WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(this.model.properties || []), [{
        name: "Propri\xE9t\xE9 " + ((this.model.properties || []).length + 1),
        kind: "tag"
      }]));
    },
    removeProperty: function removeProperty(propIndex) {
      this.$set(this.model, "properties", [].concat(__WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(this.model.properties.slice(0, propIndex)), __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(this.model.properties.slice(propIndex + 1))));
    },
    updateModel: function updateModel(value) {
      this.model = __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, value, {
        preview: __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(value, "preview.id"),
        collection: __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(value, "collection.id"),
        combination: __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(value, "combination.id"),
        combinationPart: __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(value, "combinationPart.id"),
        properties: (value && value.properties || []).filter(function (_ref8) {
          var name = _ref8.name;
          return !!name;
        }).map(function (_ref9) {
          var colors = _ref9.colors,
              props = __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_objectWithoutProperties___default()(_ref9, ["colors"]);

          return __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, props, {
            colors: __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(colors || [], "id")
          });
        }),
        images: (value && value.images || []).map(function (_ref10) {
          var id = _ref10.id;
          return id;
        })
      });
      this.modelHasCombination = !!this.model.combination;
    },
    toggleStandard: function toggleStandard(standard) {
      this.$set(this.model, "standards", __WEBPACK_IMPORTED_MODULE_6_lodash_xor___default()(this.model.standards || [], [standard]));
    },
    onSubmit: function onSubmit() {
      this.$emit("submit", __WEBPACK_IMPORTED_MODULE_4_lodash_omit___default()(__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, this.model, {
        combination: this.modelHasCombination ? this.model.combination : null,
        combinationPart: this.modelHasCombination ? this.model.combinationPart : null,
        properties: __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(this.model.properties, function (property) {
          return __WEBPACK_IMPORTED_MODULE_4_lodash_omit___default()(property, ["__typename"]);
        })
      }), ["id", "__typename", "createdAt", "updatedAt", "variants"]));
    }
  }
});

/***/ }),

/***/ 808:
/*!******************************************!*\
  !*** ./node_modules/lodash/_baseRest.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(/*! ./identity */ 123),
    overRest = __webpack_require__(/*! ./_overRest */ 736),
    setToString = __webpack_require__(/*! ./_setToString */ 737);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 809:
/*!*********************************************!*\
  !*** ./node_modules/lodash/_baseIndexOf.js ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(/*! ./_baseFindIndex */ 810),
    baseIsNaN = __webpack_require__(/*! ./_baseIsNaN */ 811),
    strictIndexOf = __webpack_require__(/*! ./_strictIndexOf */ 812);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 810:
/*!***********************************************!*\
  !*** ./node_modules/lodash/_baseFindIndex.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 811:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseIsNaN.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 812:
/*!***********************************************!*\
  !*** ./node_modules/lodash/_strictIndexOf.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 813:
/*!******************************************!*\
  !*** ./node_modules/lodash/_baseUniq.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(/*! ./_SetCache */ 406),
    arrayIncludes = __webpack_require__(/*! ./_arrayIncludes */ 798),
    arrayIncludesWith = __webpack_require__(/*! ./_arrayIncludesWith */ 799),
    cacheHas = __webpack_require__(/*! ./_cacheHas */ 408),
    createSet = __webpack_require__(/*! ./_createSet */ 814),
    setToArray = __webpack_require__(/*! ./_setToArray */ 404);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 814:
/*!*******************************************!*\
  !*** ./node_modules/lodash/_createSet.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(/*! ./_Set */ 412),
    noop = __webpack_require__(/*! ./noop */ 815),
    setToArray = __webpack_require__(/*! ./_setToArray */ 404);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 815:
/*!*************************************!*\
  !*** ./node_modules/lodash/noop.js ***!
  \*************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 816:
/*!**************************************************!*\
  !*** ./node_modules/lodash/isArrayLikeObject.js ***!
  \**************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(/*! ./isArrayLike */ 72),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 37);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 817:
/*!***********************************************************************!*\
  !*** ./node_modules/babel-runtime/helpers/objectWithoutProperties.js ***!
  \***********************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),

/***/ 818:
/*!*****************************************************************!*\
  !*** ./src/pages/combinations/graphql/CombinationListQuery.gql ***!
  \*****************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CombinationFindAllInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"results"},"name":{"kind":"Name","value":"combinationsFindAll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CombinationList"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":248}};
    doc.loc.source = {"body":"#import \"./CombinationListFragment.gql\"\n\nquery($pagination: PaginationInput, $filter: CombinationFindAllInput) {\n  results: combinationsFindAll(pagination: $pagination, filter: $filter) {\n\ttotalCount\n\tedges {\n\t  node { ...CombinationList }\n\t}\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ./CombinationListFragment.gql */ 819).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    


/***/ }),

/***/ 819:
/*!********************************************************************!*\
  !*** ./src/pages/combinations/graphql/CombinationListFragment.gql ***!
  \********************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CombinationList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Combination"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":80}};
    doc.loc.source = {"body":"fragment CombinationList on Combination {\n  id\n  name\n  parts {\n  \tid name\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CombinationList"] = oneQuery(doc, "CombinationList");
        


/***/ }),

/***/ 828:
/*!**************************************************************!*\
  !*** ./src/pages/products/graphql/ProductRemoveMutation.gql ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"productRemove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[]}]}}],"loc":{"start":0,"end":55}};
    doc.loc.source = {"body":"mutation($id: ID!) {\n  result: productRemove(id: $id)\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    


/***/ }),

/***/ 829:
/*!********************************************!*\
  !*** ./src/pages/products/ProductForm.vue ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ProductForm_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductForm.vue */ 807);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8beeb688_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductForm_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-8beeb688","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductForm.vue */ 834);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-8beeb688","scoped":false,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProductForm.vue */ 830)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ProductForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8beeb688_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 830:
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8beeb688","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/products/ProductForm.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 831:
/*!************************************!*\
  !*** ./node_modules/lodash/xor.js ***!
  \************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(/*! ./_arrayFilter */ 134),
    baseRest = __webpack_require__(/*! ./_baseRest */ 808),
    baseXor = __webpack_require__(/*! ./_baseXor */ 832),
    isArrayLikeObject = __webpack_require__(/*! ./isArrayLikeObject */ 816);

/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */
var xor = baseRest(function(arrays) {
  return baseXor(arrayFilter(arrays, isArrayLikeObject));
});

module.exports = xor;


/***/ }),

/***/ 832:
/*!*****************************************!*\
  !*** ./node_modules/lodash/_baseXor.js ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(/*! ./_baseDifference */ 833),
    baseFlatten = __webpack_require__(/*! ./_baseFlatten */ 739),
    baseUniq = __webpack_require__(/*! ./_baseUniq */ 813);

/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;
  if (length < 2) {
    return length ? baseUniq(arrays[0]) : [];
  }
  var index = -1,
      result = Array(length);

  while (++index < length) {
    var array = arrays[index],
        othIndex = -1;

    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
}

module.exports = baseXor;


/***/ }),

/***/ 833:
/*!************************************************!*\
  !*** ./node_modules/lodash/_baseDifference.js ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(/*! ./_SetCache */ 406),
    arrayIncludes = __webpack_require__(/*! ./_arrayIncludes */ 798),
    arrayIncludesWith = __webpack_require__(/*! ./_arrayIncludesWith */ 799),
    arrayMap = __webpack_require__(/*! ./_arrayMap */ 391),
    baseUnary = __webpack_require__(/*! ./_baseUnary */ 392),
    cacheHas = __webpack_require__(/*! ./_cacheHas */ 408);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),

/***/ 834:
/*!*********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8beeb688","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/products/ProductForm.vue ***!
  \*********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[(_vm.combinationsManagerVisible)?_c('modal',{attrs:{"title":"Gestion des combinaisons","size":"lg"},on:{"close":_vm.hideCombinationsManager}},[_c('combinations')],1):_vm._e(),_vm._v(" "),_c('form-sticky-header',{attrs:{"title":_vm.title,"links":{
      'form-general': 'Général',
      'form-standards': 'Normes et sécurité',
      /*'form-preview': 'Aperçu',*/ 'form-properties': 'Propriétés',
      'form-images': 'Images des déclinaisons',
    }}},[_vm._t("actions")],2),_vm._v(" "),_c('form-fieldset',{attrs:{"title":"Général","id":"form-general"}},[_c('template',{slot:"description"},[_c('p',{staticClass:"text-muted"},[_vm._v("\n        Les produits regroupent des déclinaisons, c'est-à-dire une version\n        (couleur, taille…) d'un produit. Configurez ici le produit de\n        manière générale, puis rendez-vous sur la gestion des déclinaisons\n        pour renseigner les détails de chaque référence."),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n        N'oubliez pas de "),_c('strong',[_vm._v("publier votre produit")]),_vm._v(" si celle-ci\n        n'apparaît pas dans l'interface.\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form-group',[_c('form-switch',{model:{value:(_vm.model.published),callback:function ($$v) {_vm.$set(_vm.model, "published", $$v)},expression:"model.published"}},[_vm._v("Publier ce produit")])],1)],1),_vm._v(" "),_c('row',[_c('column',{attrs:{"sm":"6"}},[_c('form-group',{attrs:{"label":"Nom du produit","required":""}},[_c('form-input',{attrs:{"type":"text","placeholder":"Ex : Gilet","required":""},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"model.name"}}),_vm._v(" "),_c('span',{attrs:{"slot":"help"},slot:"help"},[_vm._v("Le nom du produit tel qu'il apparaît dans l'interface.")])],1)],1),_vm._v(" "),_c('column',{attrs:{"sm":"6"}},[_c('form-group',{attrs:{"label":"Type","required":""}},[_c('form-select',{attrs:{"options":_vm.ProductKinds,"placeholder":"Choisir un type...","required":""},on:{"change":_vm.onChangeKind},model:{value:(_vm.model.kind),callback:function ($$v) {_vm.$set(_vm.model, "kind", $$v)},expression:"model.kind"}}),_vm._v(" "),_c('span',{attrs:{"slot":"help"},slot:"help"},[_vm._v("Une sélection de propriétés sera automatiquement complétée.")])],1)],1)],1),_vm._v(" "),_c('row',[_c('column',{attrs:{"sm":"6"}},[_c('form-group',{attrs:{"label":"Ordre d'affichage"}},[_c('form-order',{model:{value:(_vm.model.order),callback:function ($$v) {_vm.$set(_vm.model, "order", $$v)},expression:"model.order"}})],1)],1),_vm._v(" "),_c('column',{attrs:{"sm":"6"}},[_c('form-group',{attrs:{"label":"Collection"}},[_c('form-select',{attrs:{"options":_vm.collections,"placeholder":"Choisir la collection"},model:{value:(_vm.model.collection),callback:function ($$v) {_vm.$set(_vm.model, "collection", $$v)},expression:"model.collection"}}),_vm._v(" "),_c('span',{attrs:{"slot":"help"},slot:"help"},[_vm._v("Rendez-vous sur la partie\n            "),_c('router-link',{attrs:{"to":{ name: 'collections' }}},[_vm._v("collections")]),_vm._v("\n            pour gérer cette liste.")],1)],1)],1)],1),_vm._v(" "),_c('form-group',{attrs:{"label":"Combinaison / Groupe"}},[_c('span',{attrs:{"slot":"help"},slot:"help"},[_vm._v("Vous pouvez organiser les produits dans des combinaisons ou des\n        groupes afin de modifier l'affichage dans le configurateur.")]),_vm._v(" "),_c('row',[_c('column',{attrs:{"sm":"6"}},[_c('form-checkbox',{model:{value:(_vm.modelHasCombination),callback:function ($$v) {_vm.modelHasCombination=$$v},expression:"modelHasCombination"}},[_vm._v("Ce produit fait partie d'une combinaison / d'un\n            groupe")])],1),_vm._v(" "),(_vm.modelHasCombination)?_c('column',{attrs:{"sm":"6"}},[_c('row',[_c('column',{attrs:{"sm":"8"}},[_c('form-select',{attrs:{"options":_vm.combinations,"placeholder":"Choisir une combinaison / un groupe","required":""},model:{value:(_vm.modelCombination),callback:function ($$v) {_vm.modelCombination=$$v},expression:"modelCombination"}})],1),_vm._v(" "),_c('column',{attrs:{"sm":"4"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.openCombinationsManager}},[_vm._v("\n                Gérer\n              ")])])],1)],1):_vm._e()],1)],1)],2),_vm._v(" "),_c('form-fieldset',{attrs:{"title":"Normes et sécurité","id":"form-standards"}},[_c('template',{slot:"description"},[_c('p',{staticClass:"text-muted"},[_vm._v("\n        Cette section permet de renseigner les informations liées aux normes\n        de sécurité et aux risques.\n      ")])]),_vm._v(" "),_c('row',[_c('column',{attrs:{"sm":"6"}},[_c('form-group',{attrs:{"label":"Normes du produit"}},[_c('form-multiselect',{attrs:{"options":_vm.ProductStandards,"multiple":""},model:{value:(_vm.model.standards),callback:function ($$v) {_vm.$set(_vm.model, "standards", $$v)},expression:"model.standards"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"Standards"},_vm._l((_vm.ProductStandardsInfos),function(standardInfos,standard){return _c('button',{staticClass:"btn btn-default btn-icon text-grey-300",class:{
          'btn-info text-white':
            (_vm.model.standards || []).indexOf(standard) !== -1,
        },attrs:{"type":"button","title":standardInfos.name},domProps:{"innerHTML":_vm._s(standardInfos.svg)},on:{"click":function($event){return _vm.toggleStandard(standard)}}})}),0)],2),_vm._v(" "),_c('form-fieldset',{attrs:{"title":"Propriétés","id":"form-properties"}},[_c('template',{slot:"description"},[_c('p',{staticClass:"text-muted"},[_vm._v("\n        Les propriétés du produit permettent de créer des déclinaisons et de\n        proposer différentes versions du produit dans le configurateur."),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n        Selon le type de produit, une sélection est proposée : cependant\n        il faut adapter les propriétés à chaque produit, en enlever ou\n        rajouter certaines, et surtout renseigner les options possibles. Par\n        exemple, pour une couleur on choisira les différentes options\n        possibles dans la\n        "),_c('router-link',{attrs:{"to":{ name: 'colors' }}},[_vm._v("liste des couleurs")]),_vm._v(" ; pour un choix prédéfini, on proposera les options (ex :\n        « Cuir »,\n        « Synthétique »...) ; pour les vêtements,\n        on pourra choisir le sexe ; enfin, le texte libre permet de\n        renseigner des informations supplémentaires sur une déclinaison.\n      ")],1)]),_vm._v(" "),_vm._l((_vm.model.properties),function(prop,propIndex){return _c('div',{key:prop.id || propIndex},[_c('row',[_c('column',{attrs:{"lg":"2","sm":"6"}},[_c('form-group',{attrs:{"label":"Propriété","required":""}},[_c('form-input',{attrs:{"type":"text","placeholder":"Ex : Taille","required":""},model:{value:(_vm.model.properties[propIndex].name),callback:function ($$v) {_vm.$set(_vm.model.properties[propIndex], "name", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"model.properties[propIndex].name"}})],1)],1),_vm._v(" "),_c('column',{attrs:{"lg":"2","sm":"6"}},[_c('form-group',{attrs:{"label":"Type","required":""}},[_c('form-select',{class:{ 'bg-warning': _vm.isDuplicateSexProperty(prop) },attrs:{"options":_vm.ProductPropertyKinds,"required":""},model:{value:(_vm.model.properties[propIndex].kind),callback:function ($$v) {_vm.$set(_vm.model.properties[propIndex], "kind", $$v)},expression:"model.properties[propIndex].kind"}})],1)],1),_vm._v(" "),_c('column',{attrs:{"lg":"5","sm":"12"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.properties[propIndex].kind === 'text'),expression:"model.properties[propIndex].kind === 'text'"}]},[_c('form-group',{attrs:{"label":" "}},[_c('p',{staticClass:"no-margin text-muted mt-10"},[_vm._v("\n                Texte libre renseigné pour chaque déclinaison\n              ")])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.properties[propIndex].kind === 'color'),expression:"model.properties[propIndex].kind === 'color'"}]},[_c('form-group',{attrs:{"label":"Couleurs disponibles","required":""}},[_c('form-select-color',{attrs:{"colors":_vm.colors,"multiple":""},model:{value:(_vm.model.properties[propIndex].colors),callback:function ($$v) {_vm.$set(_vm.model.properties[propIndex], "colors", $$v)},expression:"model.properties[propIndex].colors"}})],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.properties[propIndex].kind === 'tag'),expression:"model.properties[propIndex].kind === 'tag'"}]},[_c('form-group',{attrs:{"label":"Options possibles","required":""}},[_c('form-tags',{model:{value:(_vm.model.properties[propIndex].tags),callback:function ($$v) {_vm.$set(_vm.model.properties[propIndex], "tags", $$v)},expression:"model.properties[propIndex].tags"}})],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.properties[propIndex].kind === 'sex'),expression:"model.properties[propIndex].kind === 'sex'"}]},[_c('form-group',{attrs:{"label":" "}},[(!_vm.isDuplicateSexProperty(prop))?_c('p',{staticClass:"no-margin text-muted mt-10"},[_vm._v("\n                Homme, Femme, Unisexe\n              ")]):_c('p',{staticClass:"no-margin text-warning text-semibold mt-10"},[_vm._v("\n                Il ne peut y avoir qu'une seule propriété Sexe\n              ")])])],1)]),_vm._v(" "),_c('column',{attrs:{"lg":"2","sm":"8"}},[_c('form-group',{attrs:{"label":" "}},[_c('form-checkbox',{model:{value:(_vm.model.properties[propIndex].required),callback:function ($$v) {_vm.$set(_vm.model.properties[propIndex], "required", $$v)},expression:"model.properties[propIndex].required"}},[_vm._v("Obligatoire")])],1)],1),_vm._v(" "),_c('column',{attrs:{"lg":"1","sm":"4"}},[_c('form-group',{staticClass:"text-right",attrs:{"label":" "}},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeProperty(propIndex)}}},[_c('i',{staticClass:"icon-bin"})])])],1)],1),_vm._v(" "),_c('hr')],1)}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.addProperty}},[_c('i',{staticClass:"icon-add"}),_vm._v(" Ajouter une propriété\n    ")])],2),_vm._v(" "),_c('form-fieldset',{attrs:{"title":"Images des déclinaisons","id":"form-images"}},[_c('template',{slot:"description"},[_c('p',{staticClass:"text-muted"},[_vm._v("\n        Téléchargez en une seule fois toutes les images des déclinaisons du\n        produit afin de pouvoir plus rapidement les utiliser par la suite.\n      ")])]),_vm._v(" "),_c('form-group',{attrs:{"label":""}},[_c('form-checkbox',{model:{value:(_vm.model.fullImage),callback:function ($$v) {_vm.$set(_vm.model, "fullImage", $$v)},expression:"model.fullImage"}},[_vm._v("Afficher en taille maximum (sans marges)")])],1),_vm._v(" "),_c('form-file-upload',{attrs:{"image":"","multiple":"","editable":""},model:{value:(_vm.model.images),callback:function ($$v) {_vm.$set(_vm.model, "images", $$v)},expression:"model.images"}})],2)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 863:
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/products/ProductEdit.vue ***!
  \***************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/asyncToGenerator */ 75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductForm_vue__ = __webpack_require__(/*! ./ProductForm.vue */ 829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_ProductDetailQuery_gql__ = __webpack_require__(/*! ./graphql/ProductDetailQuery.gql */ 916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_ProductDetailQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__graphql_ProductDetailQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_ProductUpdateMutation_gql__ = __webpack_require__(/*! ./graphql/ProductUpdateMutation.gql */ 806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_ProductUpdateMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__graphql_ProductUpdateMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_ProductRemoveMutation_gql__ = __webpack_require__(/*! ./graphql/ProductRemoveMutation.gql */ 828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_ProductRemoveMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__graphql_ProductRemoveMutation_gql__);


//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ProductForm: __WEBPACK_IMPORTED_MODULE_2__ProductForm_vue__["a" /* default */]
  },
  data: function data() {
    return {
      product: null,
      toVariants: false
    };
  },

  apollo: {
    product: {
      query: __WEBPACK_IMPORTED_MODULE_3__graphql_ProductDetailQuery_gql___default.a,
      skip: function skip() {
        return !this.$route.params.id;
      },
      variables: function variables() {
        return this.$route.params;
      }
    }
  },
  methods: {
    goToVariants: function goToVariants() {
      this.toVariants = true;
    },
    goToProducts: function goToProducts() {
      this.toVariants = false;
    },
    save: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(data) {
        var _ref2, product;

        return __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.$apollo.mutate({
                  mutation: __WEBPACK_IMPORTED_MODULE_4__graphql_ProductUpdateMutation_gql___default.a,
                  variables: {
                    id: this.product.id,
                    data: data
                  }
                });

              case 3:
                _ref2 = _context.sent;
                product = _ref2.data.productUpdate;

                this.$store.dispatch("addNotificationSuccess", "Le produit a \xE9t\xE9 mis \xE0 jour\xA0!");
                this.$router.push(this.toVariants ? { name: 'product/variants', params: { id: product.id } } : { name: 'products' });
                _context.next = 14;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                if (!_context.t0.message.match(/duplicate/)) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", this.$store.dispatch("addNotificationError", "L'alias est d\xE9j\xE0 utilis\xE9 par un autre produit\xA0!"));

              case 13:
                this.$store.dispatch("addNotificationError", _context.t0.message);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));

      function save(_x) {
        return _ref.apply(this, arguments);
      }

      return save;
    }(),
    remove: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref4, data;

        return __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.$apollo.mutate({
                  mutation: __WEBPACK_IMPORTED_MODULE_5__graphql_ProductRemoveMutation_gql___default.a,
                  variables: {
                    id: this.product.id
                  }
                });

              case 3:
                _ref4 = _context2.sent;
                data = _ref4.data;

                if (data.result) {
                  this.$store.dispatch("addNotificationSuccess", "La produit a \xE9t\xE9 supprim\xE9");
                  this.$router.push({ name: "products" });
                } else {
                  this.$store.dispatch("addNotificationError", "Le produit n'a pas \xE9t\xE9 supprim\xE9");
                }
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                this.$store.dispatch("addNotificationError", _context2.t0.message);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function remove() {
        return _ref3.apply(this, arguments);
      }

      return remove;
    }()
  }
});

/***/ }),

/***/ 916:
/*!***********************************************************!*\
  !*** ./src/pages/products/graphql/ProductDetailQuery.gql ***!
  \***********************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"product"},"name":{"kind":"Name","value":"productFetchById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductDetail"},"directives":[]}]}}]}}],"loc":{"start":0,"end":123}};
    doc.loc.source = {"body":"#import \"./ProductDetailFragment.gql\"\n\nquery($id: ID!) {\n  product: productFetchById(id: $id) {\n    ...ProductDetail\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ./ProductDetailFragment.gql */ 792).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    


/***/ }),

/***/ 917:
/*!*********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d92b002","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/products/ProductEdit.vue ***!
  \*********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-form',{attrs:{"value":_vm.product,"title":_vm.pageTitle},on:{"submit":_vm.save}},[_c('template',{slot:"actions"},[_c('form-button',{staticClass:"btn btn-link",attrs:{"kind":"default","type":"submit"},on:{"click":_vm.goToVariants}},[_c('i',{staticClass:"icon-color-sampler position-left"}),_vm._v("Gérer les déclinaisons")]),_vm._v(" "),_c('form-button',{attrs:{"kind":"submit","type":"submit"},on:{"click":_vm.goToProducts}},[_vm._v("Enregistrer")]),_vm._v(" "),_c('form-button',{attrs:{"kind":"delete"},on:{"click":_vm.remove}},[_vm._v("Supprimer")]),_vm._v(" "),_c('form-button',{attrs:{"kind":"cancel"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Annuler")])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// 2.b0bfe63f.chunk.js